import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Check } from '@/components/Icons/Check';
import styles from './DeliverInfo.module.scss';
export const DeliverInfo = ({ chatEvent }) => {
    if (chatEvent.event_type === 'user_message') {
        const time = new Date(chatEvent.created_at);
        return (_jsxs("div", { className: styles.receipt, children: [_jsx("span", { className: cn(styles.checkGroup, {
                        [styles.delivered]: !!chatEvent.read_at,
                    }), children: chatEvent.delivered_at && (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.check, children: _jsx(Check, {}) }), _jsx("span", { children: _jsx(Check, {}) })] })) }), _jsx("span", { className: styles.timeStamp, children: `${time.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                    })}` })] }));
    }
    throw new Error("Shouldn't be reachable");
};
